module.exports = __webpack_public_path__ + "static/media/Kennen.b7d494fb.png";